import { Builder } from "@builder.io/react";
import FeatureCard from "@components/RedesignComponents/FeatureCard/FeatureCard";
import { FeatureCardType } from "@components/RedesignComponents/types/FeatureCard";
import { segmentTrack } from "@utils/segment/segment-track";
import { navigate } from "gatsby";
import * as React from "react";

const FeatureCardWrapper: React.FC<FeatureCardType> = ({
  heading,
  ctaCopy,
  link,
  icon,
}) => {
  const currentLink = link?.ctaLink?.value?.data?.url || link?.ctaUrl;

  const triggerAnalytics = () => {
    segmentTrack("Link Clicked", {
      url: window.location.pathname,
      text: ctaCopy,
      target: currentLink,
      action: "Clicked",
      initiator: "User",
      object: "Link",
      source_application: "Marketing",
    });
  };

  const onClick: React.MouseEventHandler<HTMLAnchorElement> = e => {
    if (currentLink) {
      e.preventDefault();

      triggerAnalytics();

      navigate(currentLink);
    }
  };

  return (
    <FeatureCard
      heading={heading}
      ctaCopy={ctaCopy}
      link={link}
      icon={{
        image: icon?.image,
        imageAltText: icon?.imageAltText,
      }}
      onClick={onClick}
    />
  );
};

export default FeatureCardWrapper;

export const RegisterFeatureCard = () => {
  Builder.registerComponent(FeatureCardWrapper, {
    name: "content-card-molecule",
    inputs: [
      {
        name: "heading",
        type: "string",
        required: true,
      },
      {
        name: "ctaCopy",
        type: "string",
      },
      {
        name: "link",
        type: "object",
        required: false,
        subFields: [
          {
            name: "ctaLink",
            type: "reference",
            model: "page",
            helperText:
              "This is a reference link to an internal page such as /about",
          },
          {
            name: "ctaUrl",
            type: "string",
            helperText:
              "This is an external URL such as https://www.google.com/",
          },
        ],
        helperText:
          "The CTA reference link will be used by default. If it is blank, the CTA link URL will be used.",
      },
      {
        name: "icon",
        type: "object",
        subFields: [
          {
            name: "image",
            type: "file",
          },
          {
            name: "imageAltText",
            type: "longText",
          },
        ],
        helperText: "The small icon that rests above the headline.",
      },
    ],
  });
};
